import { requestBankCardList } from '@/routes/CompanyAccountManagement/services';
import {
  exportCollectionDetails,
  getAccountList,
  getCollectionDetailsList,
  getDetailsExportResult,
  getLastSyncTime,
  handleCancelMark,
  syncCollectionDetails,
} from '../services';

export default {
  namespace: 'collectionDetails',
  state: {
    hasCollectionAccount: false,
    collectionAccount: [],
  },
  effects: {
    // 托收账户查询
    *getHasCollectionAccount({ payload }, { call, put, select }) {
      const hasCollectionAccount = yield select(
        state => state.collectionDetails.hasCollectionAccount,
      );
      if (hasCollectionAccount) return;
      const res = yield call(requestBankCardList, payload);
      yield put({
        type: 'update',
        payload: {
          hasCollectionAccount: (res?.data?.length || 0) !== 0,
          collectionAccount: res?.data || [],
        },
      });
      return res?.data || [];
    },
    // 托收账户查询
    *getCollectionAccount({ payload }, { call, put, select }) {
      const res = yield call(requestBankCardList, payload);
      return res?.data || [];
    },
    // 托收明细分页查询
    *getCollectionDetailsList({ payload }, { call }) {
      return yield call(getCollectionDetailsList, payload);
    },

    // 明细导出
    *exportCollectionDetails({ payload }, { call }) {
      return yield call(exportCollectionDetails, payload);
    },

    // 获取导出结果
    *getDetailsExportResult({ payload }, { call }) {
      return yield call(getDetailsExportResult, payload);
    },

    // 托收明细最后同步时间
    *getLastSyncTime({ payload }, { call }) {
      return yield call(getLastSyncTime, payload);
    },

    // 同步托收明细
    *syncCollectionDetails({ payload }, { call }) {
      return yield call(syncCollectionDetails, payload);
    },

    // 获取托收账户列表
    *getAccountList({ payload }, { call }) {
      return yield call(getAccountList, payload);
    },

    // 标记为托收/非托收
    *handleCancelMark({ payload }, { call }) {
      return yield call(handleCancelMark, payload);
    },
  },

  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
